<template>
  <OppleModal
    :extend-style="{ width: '590px' }"
    :visible="visible"
    :is-show-warn="false"
    :is-show-cancel-btn="false"
    :ok-text="text"
    @onOk="modalClose"
    @onClose="modalClose"
  >
    <div class="tip_box">
      <div v-if="title" class="tip_box_title">
        <i class="el-icon-warning" />
        <span style="font-size: 14px;">{{ title }}</span>
      </div>
      <div class="tip_box_table">
        <el-table
          border
          :data="deviceList"
          header-row-class-name="tip_box_table_th"
          :row-style="{ backgroundColor: '#F5F8FD' }"
        >
          <el-table-column
            prop="DeviceName"
            :header-row-style="{ backgroundColor: '#fff' }"
            width="180"
            :label="$t('deviceMsg.devicename')"
          />
          <el-table-column prop="DeviceTypeName" width="130" :label="$t('install.deviceType')" />
          <el-table-column width="130" prop="Mac" label="Mac" />
          <el-table-column prop="ClassSku" label="classsku" width="150" />
          <!-- <el-table-column
            prop="FirmVersionCollection"
            width="140"
            :label="$t('deviceMsg.currentversion')"
          >
            <template slot-scope="scope">
              <div
                v-for="(item,index) in scope.row.currentVersionList"
                :key="index"
                class="bottom_border_box"
              >
                {{ item }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            :label="$t('deviceMsg.newversion')"
          >
            <template slot-scope="scope">
              <div
                v-for="(item,index) in scope.row.LatestVersionList"
                :key="index"
                class="bottom_border_box"
              >
                {{ item }}
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      
      <!-- <div v-else-if="contentJudge == 3 && otaUpdateIsShow">
        <div class="tip_box_title">
          <i class="el-icon-info" style="margin: 0 8px" />
          {{ $t('install.otaTipTitle2') }}
        </div>
        <div class="qrcode_box">
          <div class="qrcode_box_content">
            <img src="../../../assets/img/qrcode/app_download_opple_smart_system.png">
          </div>
        </div>
        <div class="tip_box_footer">
          <button @click="modalClose">
            {{ $t('install.getInfo') }}
          </button>
        </div>
      </div> -->
    </div>
  </OppleModal>
</template>

<script>
import OppleModal from '@/components/OppleModal/index.vue'

export default {
  name: 'OtaUpdateDialog',
  components: {
    OppleModal,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: 'ok',
    },
    deviceList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
    
    }
  },
  mounted() {
  },
  methods: {
    modalClose() {
      this.$emit('close');
    },
  },
}
</script>

<style lang="scss" scoped>

.tip_box {
  max-height: 500px;
  &_title {
    display: flex;
    align-items: center;
    color: #595959;
    font-size: 18px;
    i {
      width: 21px;
      height: 21px;
    }
  }
  &_empty {
    width: 100%;
    // height: 50px;
  }
  &_table {
    width: 100%;
    margin-top: 18px;
    //height: 300px;
    overflow: auto;
  }

  .qrcode_box {
    padding-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 124px;
      height: 126px;
    }
  }
  &_footer {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    button {
      min-width: 120px;
      height: 40px;
      color: #fff;
      font-size: 14px;
      margin-left: 12px;
      padding: 0 20px;
      border: 1px solid #2145a4;
      border-radius: 4px;
      background-color: #2145a4;
    }
  }
  ::v-deep.tip_box_table_th th {
    background-color: #fff !important;
  }
  >>> .el-table__cell {
    font-size: 12px;
  }
}
.bottom_border_box {
  border-bottom: 1px solid #c7c6c6;
  width: 136%;
  text-align: center;
  margin-left: -10px;
}
.bottom_border_box:last-child {
  border-bottom: none;
}


</style>
